// extracted by mini-css-extract-plugin
export var body = "_l8-0";
export var sectionHeader = "_l8-4";
export var shortcutColumns = "_l8-2";
export var shortcutList = "_l8-1";
export var shortcutSection = "_l8-3";